import produce from "immer";
import { constants } from "./actions";
import { commonConstants } from "../common/actions";

const { REQUEST, SUCCESS, FAILURE } = commonConstants;
const { FETCH_RECOGNITIONS_LIST } = constants;

const initState = {
  list: [],
  loading: false,
  error: { source: null, message: null },
  success: { source: null, message: null },
};

export default function reducer(state = initState, action) {
  switch (action.type) {
    case FETCH_RECOGNITIONS_LIST + REQUEST:
      return produce(state, (draft) => {
        draft.loading = true;
        draft.error = initState.error;
        draft.success = initState.success;
      });
    case FETCH_RECOGNITIONS_LIST + SUCCESS:
      return produce(state, (draft) => {
        draft.loading = false;
        draft.error = initState.error;
        draft.success.source = action.payload.source;
        draft.list = action.payload.data;
      });
    case FETCH_RECOGNITIONS_LIST + FAILURE:
      return produce(state, (draft) => {
        draft.loading = false;
        draft.error = {
          source: action.payload.source,
          message: action.payload.message,
        };
        draft.success = initState.success;
      });
    default:
      return state;
  }
}
